/**
 * @file
 * Placeholder file for custom sub-theme behaviors.
 *
 */


//  if (drupalSettings.path.currentLanguage === 'de' ) {
//     window.addEventListener("load", function(){
//     window.cookieconsent.initialise({
//       "palette": {
//         "popup": {
//           "background": "#015CA8",
//           "text": "#ffffff"
//         },
//         "button": {
//           "background": "#fff",
//           "text": "#015CA8"
//         }
//       },
//       "content": {
//         "message": "Diese Website nutzt Cookies, um bestmögliche Funktionalität bieten zu können.",
//         "dismiss": "Ok, verstanden",
//         "link": "Mehr erfahren",
//         "href": "/de/datenschutz"
//       }
//       })});
//   }
//   else if (drupalSettings.path.currentLanguage === 'en') {
//     window.addEventListener("load", function(){
//     window.cookieconsent.initialise({
//       "palette": {
//         "popup": {
//           "background": "#015CA8",
//           "text": "#ffffff"
//         },
//         "button": {
//           "background": "#fff",
//           "text": "#015CA8"
//         }
//       },
//       "content": {
//         "message": "This website uses cookies to provide the best possible user experience.",
//         "dismiss": "Understood",
//         "link": "Details",
//         "href": "/en/privacy"
//       }
//        })});
//   }
//   else {
//     window.addEventListener("load", function(){
//     window.cookieconsent.initialise({
//       "palette": {
//         "popup": {
//           "background": "#015CA8",
//           "text": "#ffffff"
//         },
//         "button": {
//           "background": "#fff",
//           "text": "#015CA8"
//         }
//       },
//       "content": {
//         "message": "Diese Website nutzt Cookies, um bestmögliche Funktionalität bieten zu können.",
//         "dismiss": "Ok, verstanden",
//         "link": "Mehr erfahren",
//         "href": "/de/datenschutz"
//       }
//        })});
//   }






(function ($, Drupal) {

  /**
   * Use this behavior as a template for custom Javascript.
   */
   // Drupal.behaviors.exampleBehavior = {
   //   attach: function (context, settings) {
   //     //alert("I'm alive!");
   //   };

  Drupal.behaviors.intFoundation = {
    attach: function (context, settings) {
      $(context).foundation();
    }
  };
  Drupal.behaviors.foundation = {
    attach: function (context, settings) {
      // $('.orbit-container').foundation();
      $('.header-slider .orbit-container li:first').addClass('is-active');

      $(".orbit-wrapper").each(function() {
          var orbitWrapper = $(this);
          var numberOfSlides = orbitWrapper.find(".orbit-container li").length;
          if (numberOfSlides === 1) {
              orbitWrapper.find(".orbit-controls").hide();
          }
      });
      
    }
  };
  Drupal.behaviors.paragraph = {
    attach: function (context, settings) {
      $('.swp-text').removeClass('swp-text').addClass('grid-padding-x swp-text');

      $('.video-media').each(function(){
        var preview = $(this).find('.video-media-preview img').attr('src'); //.replace(/\?.*/,'')
        $(this).find('div.video-js video').attr('poster', preview);
        $(this).find('div.video-js').children('video').attr('poster', preview);
        //$(this).find('.video-media video').css('background-image', 'url(' + preview + ')');
        $(this).find('.video-media-preview').hide();

      });

      //videojs('video-js-media');

    }
  };

// ===== Scroll to Top ====
// $(window).scroll(function() {
//     if ($(this).scrollTop() >= 50) {        // If page is scrolled more than 50px
//         $('#return-to-top').fadeIn(200);    // Fade in the arrow
//     } else {
//         $('#return-to-top').fadeOut(200);   // Else fade out the arrow
//     }
// });
// $('#return-to-top').click(function() {      // When arrow is clicked
//     $('body,html').animate({
//         scrollTop : 0                       // Scroll to top of body
//     }, 500);
// });

 $('#edit-mail').after('<i class="fa contact fa-envelope-o" aria-hidden="true"><i/>');

 // if ($('body').hasClass('lang-de') && $('body').hasClass('path-contact')) {
 //   $('.poma-bar > div.columns').append('<div class="colorbar"><h2><strong>POMA</strong> Systems<br />Efficiency for your success. German technology.</h2></div>');
 // }
 // else if ($('body').hasClass('lang-en') && $('body').hasClass('path-contact')) {
 //   $('.poma-bar > div.columns').append('<div class="colorbar"><h2><strong>POMA</strong> Systems<br />Efficiency for your success. German technology.</h2></div>');
 // }
 // else if ($('body').hasClass('lang-de') && $('body').hasClass('path-referenzen')) {
 //   $('.poma-bar > div.columns').append('<div class="colorbar"><h2><strong>POMA</strong> Systems<br />Tue Gutes und rede darüber.</h2></div>');
 // }
 // else if ($('body').hasClass('lang-en') && $('body').hasClass('path-referenzen')) {
 //   $('.poma-bar > div.columns').append('<div class="colorbar"><h2><strong>POMA</strong> Systems<br />Create good things and talk about it</h2></div>');
 // }

 if ($('body').hasClass('lang-en')) {
    $('li.has-dropdown > a[href="/en/company/career"]').next().remove();
 	$('a[href="/en/company/career"]').parent().removeClass('has-dropdown not-click');
}
// $("#sidebar-first a").each(function() {
//    var $this = $(this);
//    var _href = $this.attr("href");
//    $this.attr("href", _href + '#breadcrumbs');
//   });

//
//   $('#sidebar-first a[href^=#]').on('click', function(e){
//     var href = $(this).attr('href');
//     $('html, body').animate({
//         scrollTop:$(href).offset().top
//     },'slow');
//     e.preventDefault();
// });

// to top right away
// if ( window.location.hash ) scroll(0,0);
// // void some browsers issue
// setTimeout( function() { scroll(0,0); }, 1);

$(function() {

    // your current click function
    $('.scroll').on('click', function(e) {
        e.preventDefault();
        $('html, body').animate({
            scrollTop: $($(this).attr('href')).offset().top + 'px'
        }, 1000, 'swing');
    });

    // *only* if we have anchor on the url
    if(window.location.hash) {

        // smooth scroll to the anchor id
        $('html, body').animate({
            scrollTop: $(window.location.hash).offset().top + 'px'
        }, 1000, 'swing');
    }

});
  $('.referenzen').unwrap().last().addClass( "end" );
  $('.referenzen').wrapAll("<div id='referenzen-wrapper' class='grid-x' />");
  $('.referenzen-kat').unwrap();
  $('.referenzen-kat').wrapAll("<div id='referenzen-kat-wrapper' class='grid-x' />");

  $.each($("#referenzen-wrapper > .referenzen"), function(index, value){
           var num = index + 1;
           $(value).attr('data-myorder', num);
       });

       
  if (drupalSettings.path.currentLanguage === 'en') {
    $('#referenzen-kat-wrapper').prepend('<div class="referenzen-kat filter none" data-filter="all">All</div>');
  }
  if (drupalSettings.path.currentLanguage === 'de') {
    $('#referenzen-kat-wrapper').prepend('<div class="referenzen-kat filter none" data-filter="all">Alle</div>');
  }

  $('.referenzen-kat.Allgemein').attr('data-filter', '.Allgemein');
  $('.referenzen-kat.Automobil').attr('data-filter', '.Automobil');
  $('.referenzen-kat.Lackiersysteme').attr('data-filter', '.Lackiersysteme');
  $('.referenzen-kat.Anlagenhersteller').attr('data-filter', '.Anlagenhersteller');
  $('.referenzen-kat.Lackhersteller').attr('data-filter', '.Lackhersteller');
  $('.referenzen-kat.TierOne').attr('data-filter', '.TierOne');
  $('.referenzen-kat.Vertriebspartner').attr('data-filter', '.Vertriebspartner');

  $('#referenzen-wrapper').mixItUp({
  	animation: {
  		effects: 'fade translateZ(500px)',
  		duration: 300
  	},
  	selectors: {
  		target: 'div'
  	}
  });




})(jQuery, Drupal);
